import type { Dispatch, SetStateAction } from "react";
import { SiteState, StaticState } from "./SiteStateTypes";
import { mockWebsocketReturns } from "./mockWebsocketReturns";

const MOCK_WEBSOCKET_RETURN_INTERVAL_SECONDS = 5;
const MOCK_WEBSOCKET_RETURN_INDEX_START = 0;
const MOCK_WEBSOCKET_RETURN_INDEX_END = mockWebsocketReturns.length;


export const mockWebsocketRunner = (staticState: StaticState, setSiteState: Dispatch<SetStateAction<SiteState | undefined>>) => {
    let currMockWebsocketReturnIndex = MOCK_WEBSOCKET_RETURN_INDEX_START;

    const interval = setInterval(() => {
        if (currMockWebsocketReturnIndex > MOCK_WEBSOCKET_RETURN_INDEX_END) {
            return;
        }

        const currentMockWebsocketReturn = mockWebsocketReturns[currMockWebsocketReturnIndex];

        if (currentMockWebsocketReturn.phoneNumber === staticState.phoneNumber) {
            setSiteState({ staticState: staticState, dynamicState: currentMockWebsocketReturn.dynamicSiteState });
        }

        currMockWebsocketReturnIndex++;

    }, MOCK_WEBSOCKET_RETURN_INTERVAL_SECONDS * 1000);

    return () => {
        clearInterval(interval);
    };
}